// 클립보드 복사 헬퍼 (HTTP 환경 폴백 포함).
// 보안 컨텍스트(HTTPS)에선 navigator.clipboard, 아니면 textarea + execCommand 폴백.
export function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }
  // HTTP 환경 폴백: textarea + execCommand
  return new Promise((resolve, reject) => {
    const el = document.createElement('textarea');
    el.value = text;
    el.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0';
    document.body.appendChild(el);
    el.focus();
    el.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(el);
    ok ? resolve() : reject();
  });
}
